import { useTranslation } from 'react-i18next';

import { Body, Title } from '../../../components/Typography';
import { Category } from '../../../services/helpCenter';

export function CategoryRow({
  icon,
  title,
  count,
  onClick,
}: {
  icon?: string;
  title: string;
  count: number;
  onClick?: () => void;
}) {
  const { t } = useTranslation();
  const id = title.toLocaleLowerCase().replace(' ', '-');
  return (
    <button
      id={`ostro-tailor-category-${id}`}
      onClick={onClick}
      className="ostro-tailor-category text-sm flex justify-between items-center py-4 gap-2 block w-full text-left"
    >
      {icon && (
        <img
          src={icon}
          alt={`${title} icon`}
          className="w-6"
        />
      )}
      <Title className="grow text-typography-heading">{title}</Title>
      <Body className="text-typography-secondary">{t('itemWithCount', { count })}</Body>
    </button>
  );
}

export default function TailorCategories({
  className,
  onClickCategory,
  categories,
}: {
  className?: string;
  onClickCategory?: (category: Category, index: number) => void;
  categories?: Category[];
}) {
  return (
    <div
      id="ostro-tailor-categories-container"
      className={className}
    >
      {categories?.map((category: Category, index) => (
        <CategoryRow
          icon={category.icon}
          key={category.id}
          title={category.name}
          count={category.article_count}
          onClick={() => onClickCategory?.(category, index)}
        />
      ))}
    </div>
  );
}
